import { render, staticRenderFns } from "./BrightSales.vue?vue&type=template&id=f7a1e854"
import script from "./BrightSales.vue?vue&type=script&lang=js"
export * from "./BrightSales.vue?vue&type=script&lang=js"
import style0 from "./BrightSales.vue?vue&type=style&index=0&id=f7a1e854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports